var _path;
/*
 * The MIT License (MIT)
 *
 * Copyright (c) 2015 - present Instructure, Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */
import { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
class IconBlueprintSolid extends Component {
  constructor(...args) {
    super(...args);
    this.ref = null;
    this.handleRef = el => {
      const elementRef = this.props.elementRef;
      this.ref = el;
      if (typeof elementRef === 'function') {
        elementRef(el);
      }
    };
  }
  render() {
    return _jsx(SVGIcon, {
      ...this.props,
      name: "IconBlueprint",
      viewBox: "0 0 1920 1920",
      elementRef: this.handleRef,
      children: _path || (_path = _jsx("path", {
        d: "M790.589 1750.588v56.471h56.47V1920H677.647v-169.412h112.942Zm417.794 56.471V1920h-180.662v-112.941h180.662Zm361.433 0V1920h-180.662v-112.941h180.662ZM1920 1750.588V1920h-169.412v-112.941h56.471v-56.471H1920ZM1581.177 338.824v225.882h-112.942V451.765H451.765v1016.47h112.941v112.942H338.824V338.824h1242.353ZM1920 1389.265v180.662h-112.941v-180.662H1920Zm-1129.412-.111v180.662H677.647v-180.662h112.941ZM1242.353 0v225.882h-112.941v-112.94H112.941v1016.47h112.941v112.94H0V0h1242.353ZM1920 1027.831v180.661h-112.941v-180.661H1920Zm-1129.412-.11v180.662H677.647v-180.662h112.941ZM1920 677.647v169.412h-112.941v-56.47h-56.471V677.647H1920Zm-1072.942 0v112.942h-56.47v56.47h-112.94V677.647h169.41Zm361.434 0v112.941h-180.661V677.647h180.661Zm361.435 0v112.941h-180.662V677.647h180.662Z",
        fillRule: "evenodd"
      }))
    });
  }
}
IconBlueprintSolid.glyphName = 'blueprint';
IconBlueprintSolid.variant = 'Solid';
IconBlueprintSolid.displayName = 'IconBlueprintSolid';
// eslint-disable-next-line react/forbid-foreign-prop-types
IconBlueprintSolid.propTypes = {
  ...SVGIcon.propTypes
};
IconBlueprintSolid.allowedProps = [...SVGIcon.allowedProps];
export default IconBlueprintSolid;
export { IconBlueprintSolid };